<template>
  <b-container class="p-5">

    <b-card-header class="card-main-header">
      <h3 class="text-center">Frequently Asked Questions</h3>
    </b-card-header>
    <b-card class="card-main">

        <div v-for="accordion in accordions" v-bind:key="accordion.id">
          <b-button block href="#" v-b-toggle="`accordion-${accordion.id}`" class="btn-lg btn-block shadow-none rounded-0 p-3 border-0 faq-button">
            {{ accordion.title }}
          </b-button>
          <b-collapse :id="`accordion-${accordion.id}`" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <ul class="text-left" v-if="isElementArray(accordion.text)">
                  <li class="pb-3" v-for="element in accordion.text" v-bind:key="element.id">
                    {{ element.text }}
                  </li>
                </ul>
                <p v-else class="preserve-whitespace">
                  {{ accordion.text }}
                </p>
                </b-card-text>
            </b-card-body>
          </b-collapse>
        </div>
    </b-card>

  </b-container>
</template>

<script>

export default {
  data() {
    return {
      accordions: [
        {
          id: 1,
          title: 'I just donated, but why have I not received my perks?',
          text: 'After donating, it will take a map change for perks to become active. \n\
                For servers with maps that run 24 hours a day, it will take a server restart \n\
                for the perks to come into effect. These happen every day at 5am in the corresponding \n\
                timezone of the server.'
        },
        {
          id: 2,
          title: 'What are the donator specific rules?',
          text: [
            {
              id: 1,
              text: 'Do not call votes on yourself'
            },
            {
              id: 2,
              text: 'Do not call votes on friends or people asking for it'
            },
            {
              id: 3,
              text: 'Do not call votes as a joke'
            },
            {
              id: 4,
              text: 'Do not use donator commands to gain an advantage'
            }
          ]
        },
        {
          id: 3,
          title: 'Why have I not received my perks after 24 hours?',
          text: 'We appologize for the inconvenience. There might have been an error in the system. \n\
          Please try to get in contact with Benedevil as quick as possible.'
        },
        {
          id: 4,
          title: 'Why can\'t I see my in-game tag after enabling it?',
          text: 'You will have to pick a color first before the tag becomes visible'
        },
        {
          id: 5,
          title: 'Why did I suddenly lose my perks?',
          text: 'We might have noticed a misconduct of your perks and removed them as a result of it. \n\
          Sometimes we also experience database issues in certain regions. You can always contact Benedevil about this.'
        },
        {
          id: 6,
          title: 'How do I report a perk abuser?',
          text: 'The easiest way for us to be able to handle such situation quickly, is for \n\
          you to record a demo and collect evidence. Then make a report on the forums.'
        },
        {
          id: 7,
          title: 'When do my perks expire?',
          text: 'You can see the days till expiration on the dashboard when logged in into this website'
        },
        {
          id: 8,
          title: 'How can I get a donator rank on discord?',
          text: 'If you navigate to the dasboard, you will see a button that will allow you to connect/disconnect your discord account. \n\
          After this, it might take up to a day for you to receive a rank on discord. \n\
          Bear in mind that you must be logged in via steam to view the dasboard.'
        },
        {
          id: 9,
          title: 'What commands can I use as a donator?',
          text: ' \n\
          General commands \n\
          /ccc - Custom chat color (menu). \n\
          /dm - Change your welcome message. \n\
          /ks - Change to a permanent killstreak count. \n\
          /mypitch - (no JB) Set your voice command pitch. (24 low - 100 normal - 256 high). \n\
          /voicefx - changeyour voice command effects. \n\
          /resizemyhands - Resize your hands. \n\
          /resizemyhead - Resize your head. \n\
          /footprints - get a cool footprint effect. \n\
          /robot - Be a Robot! \n\
          /skeleton - Turn into a Skeleton. \n\
          /sethale - (VSH Only) Choose the hale you want to be. \n\
          \n\
          Vote commands \n\
          /votespec - [User/user steam id] [Reason] (have a vote on changing someone to spectator.) \n\
          /votegag - [User/user steam id] [Reason] (Have a vote on gagging someone.) \n\
          /votemute - [User/user steam id] [Reason] (Have a vote on muting someone.) \n\
          /votesilance - [User/user steam id] [Reason] (Have a vote on silencing someone.) \n\
          /voteslay - [User/user steam id] [Reason] (Have a vote on slaying someone.) \n\
          /voteteamban - [User/user steam id] [Reason] (JB Only) Have a vote on teambanning someone.) \n\
          '
        }
      ]
    }
  },
  methods: {
    isElementArray: function(element) {
      return Array.isArray(element)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FAQ.vue